/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_01_Detail_Beginner_0_HeadingInputs */

const en_method_content_step_01_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where to begin`)
};

const es_method_content_step_01_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por dónde empezar`)
};

const de_method_content_step_01_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wo soll ich anfangen?`)
};

const zh_method_content_step_01_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从哪里开始`)
};

const ar_method_content_step_01_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`من أين تبدأ`)
};

const fr_method_content_step_01_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Par où commencer`)
};

const vi_method_content_step_01_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bắt đầu từ đâu`)
};

const sw_method_content_step_01_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mahali pa kuanzia`)
};

const th_method_content_step_01_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เริ่มต้นจากตรงไหน`)
};

const bs_method_content_step_01_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gdje početi`)
};

const ja_method_content_step_01_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`どこから始めるか`)
};

const ko_method_content_step_01_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`어디서부터 시작할까`)
};

const pt_method_content_step_01_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por onde começar`)
};

const it_method_content_step_01_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Da dove cominciare`)
};

const sv_method_content_step_01_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Var du börjar`)
};

const nl_method_content_step_01_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waar je begint`)
};

const da_method_content_step_01_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvor du begynder`)
};

const nb_method_content_step_01_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvor du begynner`)
};

const fi_method_content_step_01_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mistä aloittaa`)
};

const pl_method_content_step_01_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Od czego zacząć`)
};

const ru_method_content_step_01_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`С чего начать`)
};

const tr_method_content_step_01_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nereden başlamalı`)
};

const hi_method_content_step_01_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शुरुआत कहाँ से करें`)
};

const id_method_content_step_01_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dari mana harus memulai`)
};

const ms_method_content_step_01_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Di mana hendak bermula`)
};

const cs_method_content_step_01_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kde začít`)
};

const el_method_content_step_01_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Από πού να ξεκινήσετε`)
};

const he_method_content_step_01_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מאיפה מתחילים`)
};

const af_method_content_step_01_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waar om te begin`)
};

const hu_method_content_step_01_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hol kezdd`)
};

/**
* | output |
* | --- |
* | "Where to begin" |
*
* @param {Method_Content_Step_01_Detail_Beginner_0_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_01_detail_beginner_0_heading = /** @type {((inputs?: Method_Content_Step_01_Detail_Beginner_0_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_01_Detail_Beginner_0_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_01_detail_beginner_0_heading(inputs)
	if (locale === "de") return de_method_content_step_01_detail_beginner_0_heading(inputs)
	if (locale === "zh") return zh_method_content_step_01_detail_beginner_0_heading(inputs)
	if (locale === "ar") return ar_method_content_step_01_detail_beginner_0_heading(inputs)
	if (locale === "fr") return fr_method_content_step_01_detail_beginner_0_heading(inputs)
	if (locale === "vi") return vi_method_content_step_01_detail_beginner_0_heading(inputs)
	if (locale === "sw") return sw_method_content_step_01_detail_beginner_0_heading(inputs)
	if (locale === "th") return th_method_content_step_01_detail_beginner_0_heading(inputs)
	if (locale === "bs") return bs_method_content_step_01_detail_beginner_0_heading(inputs)
	if (locale === "ja") return ja_method_content_step_01_detail_beginner_0_heading(inputs)
	if (locale === "ko") return ko_method_content_step_01_detail_beginner_0_heading(inputs)
	if (locale === "pt") return pt_method_content_step_01_detail_beginner_0_heading(inputs)
	if (locale === "it") return it_method_content_step_01_detail_beginner_0_heading(inputs)
	if (locale === "sv") return sv_method_content_step_01_detail_beginner_0_heading(inputs)
	if (locale === "nl") return nl_method_content_step_01_detail_beginner_0_heading(inputs)
	if (locale === "da") return da_method_content_step_01_detail_beginner_0_heading(inputs)
	if (locale === "nb") return nb_method_content_step_01_detail_beginner_0_heading(inputs)
	if (locale === "fi") return fi_method_content_step_01_detail_beginner_0_heading(inputs)
	if (locale === "pl") return pl_method_content_step_01_detail_beginner_0_heading(inputs)
	if (locale === "ru") return ru_method_content_step_01_detail_beginner_0_heading(inputs)
	if (locale === "tr") return tr_method_content_step_01_detail_beginner_0_heading(inputs)
	if (locale === "hi") return hi_method_content_step_01_detail_beginner_0_heading(inputs)
	if (locale === "id") return id_method_content_step_01_detail_beginner_0_heading(inputs)
	if (locale === "ms") return ms_method_content_step_01_detail_beginner_0_heading(inputs)
	if (locale === "cs") return cs_method_content_step_01_detail_beginner_0_heading(inputs)
	if (locale === "el") return el_method_content_step_01_detail_beginner_0_heading(inputs)
	if (locale === "he") return he_method_content_step_01_detail_beginner_0_heading(inputs)
	if (locale === "af") return af_method_content_step_01_detail_beginner_0_heading(inputs)
	if (locale === "hu") return hu_method_content_step_01_detail_beginner_0_heading(inputs)
	return en_method_content_step_01_detail_beginner_0_heading(inputs)
});